module.exports = __webpack_public_path__ + "images/directory/icons/compliant.ae7e63776f2f61b39c2b.svg";